import { ENGLISH_LANGUAGE, RUSSIAN_LANGUAGE } from '../../../i18n';

import { JSON_META_SCHEMA_EN } from './const.en';
import { JSON_META_SCHEMA_RU } from './const.ru';

export const JSON_SCHEMA_URL = 'http://json-schema.org/draft-07/schema#';
export const JSON_META_SCHEMA = JSON_META_SCHEMA_EN;

export const JSON_META_SCHEMAS: { [key: string]: unknown } = {
  [ENGLISH_LANGUAGE]: JSON_META_SCHEMA_EN,
  [RUSSIAN_LANGUAGE]: JSON_META_SCHEMA_RU,
};
